import _ from 'lodash';
import angular from 'angular';


let multiselectController = function ($scope, $element, $document, $compile) {
  let popupMenu = null;

  var $dropdownTrigger = $element.children()[0];
  $scope.selectedAll = $scope.options.filter(i=> !i.disabled).length === $scope.selectedModel.length || false;

  $scope.externalEvents = {
    onItemSelect: angular.noop,
    onItemDeselect: angular.noop,
    onSelectAll: angular.noop,
    onDeselectAll: angular.noop,
    onInitDone: angular.noop,
    onMaxSelectionReached: angular.noop
  };

  $scope.settings = {
    dynamicTitle: true,
    scrollable: true,
    scrollableHeight: '300px',
    displayProp: 'label',
    idProp: 'id',
    externalIdProp: 'id',
    enableSearch: false,
    selectionLimit: 0,
    showCheckAll: true,
    showUncheckAll: true,
    buttonClasses: 'btn btn-default',
    closeOnDeselect: false,
    groupBy: undefined,
    groupByTextProvider: null,
    smartButtonMaxItems: 0,
    smartButtonTextConverter: angular.noop
  };

  $scope.texts = {
    checkAll: 'Check All',
    uncheckAll: 'Uncheck All',
    selectionCount: 'checked',
    selectionOf: '/',
    searchPlaceholder: 'Search...',
    buttonDefaultText: 'Select',
    dynamicButtonTextSuffix: 'checked'
  };

  angular.extend($scope.settings, $scope.extraSettings || []);
  angular.extend($scope.externalEvents, $scope.events || []);
  angular.extend($scope.texts, $scope.translationTexts);

  $scope.toggleDropdown = function () {
    $scope.selectedAll = $scope.options.filter(i=> !i.disabled).length === $scope.selectedModel.length;
    if(!popupMenu) {
      bindPopup();
    }

    if($scope.open){
      $document.unbind('click', clickHandler);
      popupMenu.remove();
      popupMenu = null;
      $scope.open = false;
    } else {
      $document.bind('click', clickHandler);
      $scope.open = true;
    }
  };

  function buildPopupMenu() {
    return `<ul class="dropdown-menu dropdown-menu-appendToBody_{{$scope.$id}}" ng-class="{'open': open}"ng-style="{display: open ? 'block' : 'none', height : settings.scrollable ? settings.scrollableHeight : 'auto' }" style="overflow: scroll" >
    <li ng-hide="!settings.showCheckAll">
        <a role="menuitem" tabindex="-1" ng-click="selectAll($event)">
          <div class="multiselect_checkbox">          
              <input class="checkboxInput" type="checkbox" ng-model="selectedAll"/>
              <label>{{texts.checkAll}}</label>
          </div>
        </a>
    </li>
    <li ng-show="settings.showCheckAll" class="divider"></li>
    <li role="presentation" ng-repeat="option in options track by option.id">
        <a role="menuitem" tabindex="-1" ng-disabled="{{option.disabled}}" ng-click="setSelectedItem($event, getPropertyForObject(option,settings.idProp),false, option.disabled)">
          <div class="multiselect_checkbox">
              <input class="checkboxInput" type="checkbox" ng-disabled="{{option.disabled}}" ng-checked="isChecked(getPropertyForObject(option,settings.idProp))" /> 
              <label>{{getPropertyForObject(option, settings.displayProp)}}</label>
          </div>
        </a>
    </li>
  </ul>`;
  }

  function bindPopup() {
    let templateString = buildPopupMenu();
    popupMenu = $compile(angular.element(templateString))($scope);
    $document.find('body').append(popupMenu);
    // grab the new offset position
    var eOffset = $element.offset();

    // make sure to place it where it would normally go (this could be improved)
    popupMenu.css({
      'display': 'block',
      'top': eOffset.top + $element.outerHeight(),
      'left': eOffset.left
    });
  }

  function getFindObj(id) {
    var findObj = {};

    if ($scope.settings.externalIdProp === '') {
      findObj[$scope.settings.idProp] = id;
    } else {
      findObj[$scope.settings.externalIdProp] = id;
    }

    return findObj;
  }

  function clearObject(object) {
    for (var prop in object) {
      delete object[prop];
    }
  }

  function clickHandler (e) {
    var target = e.target.parentElement;
    var parentFound = false;
            
    while (angular.isDefined(target) && target !== null && !parentFound) {
      if (_.includes(target.className.split(' '), 'multiselect-parent') && !parentFound) {
        if (target === $dropdownTrigger) {
          parentFound = true;
        }
      }
      target = target.parentElement;
    }

    if (!parentFound) {
      $document.unbind('click', clickHandler);
      $scope.$apply(function () {
        $scope.open = false;
        popupMenu.remove();
        popupMenu = null;
      });
    }
  }

  if ($scope.singleSelection) {
    if (angular.isArray($scope.selectedModel) && $scope.selectedModel.length === 0) {
      clearObject($scope.selectedModel);
    }
  }

  $scope.$on('$destroy', function() {
    if(popupMenu){
      popupMenu.remove();
      popupMenu = null;
    }
    $document.unbind('click', clickHandler);
    $document.find('.dropdown-menu-appendToBody.open').hide();
  });

  $scope.getButtonText = function () {
    if ($scope.settings.dynamicTitle && ($scope.selectedModel.length > 0 || (angular.isObject($scope.selectedModel) && _.keys($scope.selectedModel).length > 0))) {
      if ($scope.settings.smartButtonMaxItems > 0) {
        var itemsText = [];

        angular.forEach($scope.options, function (optionItem) {
          if ($scope.isChecked($scope.getPropertyForObject(optionItem, $scope.settings.idProp))) {
            var displayText = $scope.getPropertyForObject(optionItem, $scope.settings.displayProp);
            var converterResponse = $scope.settings.smartButtonTextConverter(displayText, optionItem);

            itemsText.push(converterResponse ? converterResponse : displayText);
          }
        });

        if ($scope.selectedModel.length > $scope.settings.smartButtonMaxItems) {
          itemsText = itemsText.slice(0, $scope.settings.smartButtonMaxItems);
          itemsText.push('...');
        }

        return itemsText.join(', ');
      } else {
        var totalSelected;

        if ($scope.singleSelection) {
          totalSelected = ($scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp])) ? 1 : 0;
        } else {
          totalSelected = angular.isDefined($scope.selectedModel) ? $scope.selectedModel.length : 0;
        }

        if (totalSelected === 0) {
          return $scope.texts.buttonDefaultText;
        } else {
          return totalSelected === 1 ? totalSelected + ' ' + $scope.texts.dynamicButtonTextSuffix: totalSelected + ' ' + $scope.texts.dynamicButtonTextSuffix+'s';
        }
      }
    } else {
      return $scope.texts.buttonDefaultText;
    }
  };

  $scope.getPropertyForObject = function (object, property) {
    if (angular.isDefined(object) && object.hasOwnProperty(property)) {
      return object[property];
    }

    return '';
  };

  $scope.selectAll = function ($event) {
    if($scope.selectedModel.length === $scope.options.filter(i=> !i.disabled).length){
      $scope.deselectAll(true);
      $scope.selectedAll = false;
      $event.stopImmediatePropagation();
    } else {
      $scope.deselectAll(false);
      $scope.externalEvents.onSelectAll();

      angular.forEach($scope.options, function (value) {
        $scope.setSelectedItem($event, value[$scope.settings.idProp], true, value.disabled);
      });
    }
  };

  $scope.deselectAll = function (sendEvent) {
    sendEvent = sendEvent || true;

    if (sendEvent) {
      $scope.externalEvents.onDeselectAll();
    }

    if ($scope.singleSelection) {
      clearObject($scope.selectedModel);
    } else {
      $scope.selectedModel.splice(0, $scope.selectedModel.length);
    }
  };

  $scope.setSelectedItem = function ($event, id, dontRemove, disabled) {
    if(disabled){
      $event.stopPropagation();
      return false;
    }
    
    var findObj = getFindObj(id);
    var finalObj = null;

    if ($scope.settings.externalIdProp === '') {
      finalObj = _.find($scope.options, findObj);
    } else {
      finalObj = findObj;
    }

    if ($scope.singleSelection) {
      clearObject($scope.selectedModel);
      angular.extend($scope.selectedModel, finalObj);
      $scope.externalEvents.onItemSelect(finalObj);

      return;
    }

    dontRemove = dontRemove || false;

    var exists = _.findIndex($scope.selectedModel, findObj) !== -1;

    if (!dontRemove && exists) {
      $scope.selectedModel.splice(_.findIndex($scope.selectedModel, findObj), 1);
      $scope.selectedAll = $scope.selectedModel.length === $scope.options.filter(i=> !i.disabled).length;
      $scope.externalEvents.onItemDeselect(findObj);
    } else if (!exists && ($scope.settings.selectionLimit === 0 || $scope.selectedModel.length < $scope.settings.selectionLimit)) {
      $scope.selectedModel.push(finalObj);
      $scope.selectedAll = $scope.selectedModel.length === $scope.options.filter(i=> !i.disabled).length;
      $scope.externalEvents.onItemSelect(finalObj);
    }

    $event.stopImmediatePropagation();
  };

  $scope.isChecked = function (id) {
    if ($scope.singleSelection) {
      return $scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp]) && $scope.selectedModel[$scope.settings.idProp] === getFindObj(id)[$scope.settings.idProp];
    }

    return _.findIndex($scope.selectedModel, getFindObj(id)) !== -1;
  };

  $scope.externalEvents.onInitDone();
};


multiselectController.$inject = ['$scope', '$element', '$document', '$compile'];
export default multiselectController;


// WEBPACK FOOTER //
// ./app/common/multiselect/multiselect.controller.js